import { act } from "react-dom/test-utils";
import {
  FIN_BORINGLOAD,
  CHANGE_REGNUM,
  ADD_DS,
  CHANGE_DS,
  CHANGE_ALLDS,
  CHANGE_BORDS,
  DEL_DS,
  CHANGE_SELROW,
  ISDEL,
  CHANGE_LISTCAT,
  CHANGE_SHOWCHK,
  CHANGE_USECHK,
  ADD_CAT,
  DEL_CAT,
  CHANGE_CATNAME,
  CHANGE_CATSELROW,
  CHANGE_NAME,
  CHANGE_CAT,
  CHANGE_GEOINFO,
  CHANGE_COORDSYSTEM,
  CHANGE_COLOR,
  CHANGE_TAB,
  ISOK,
  ISDRAW,
  CHANGE_FILE,
  CHANGE_XATTR,
  CHANGE_YATTR,
  CHANGE_DEPTHKRDO,
  CHANGE_ZATTR,
  CHANGE_GEO,
  CHANGE_ID,
  CHANGE_GLCHK,
  CHANGE_GL,
  CHANGE_WLCHK,
  CHANGE_WL,
  CHANGE_HEADERNUM,
  CHANGE_FIELDNAMECHK,
  CHANGE_CSVDATA,
  CHANGE_NEWDATA,
  CHANGE_FORMDATA,
  CHANGE_USERBORINGDATA,
  ADD_POINT,
  DEL_POINT,
  CHANGE_FIELD,
  CHANGE_SELROWP,
  IS_DELP,
  CHANGE_NEWDS,
  ADD_LASTGEO,
  CHANGE_BCOLOR,
  CHANGE_EXVARCAT,
  CHANGE_EXVARNAME,
  CHANGE_EXVARNAMEOPT,
  CHANGE_ANALYRADIUS,
  CHANGE_ANALYBHHEIGHT,
  CHANGE_ANALYPUMP,
  CHANGE_ANALYWL,
  CHANGE_MESHRADIUS,
  CHANGE_MESHVERTEX,
  CHANGE_MESHSPLIT,
  CHANGE_MESHZSPLIT,
  CHANGE_MESHBIAS,
  CHANGE_ANALYTARGET,
  CHANGE_POMPAMOUNT,
  CHANGE_WLDAMOUNT,
  CHANGE_MODELKIND,
  ADD_POMPTR,
  ADD_SCREENTR,
  DEL_POMPTR,
  DEL_SCREENTR,
  UPDATE_POMPTR,
  CHANGE_POMPTRSELROW,
  CHANGE_SCREENZSPLIT,
  CHANGE_MAPMESHLAY,
  CHANGE_EQUPERMCHECK,
  CHANGE_PROBTHRESHOLD,
  CHANGE_CROSSVALID,
  ADD_WELLSTR,
  UPDATE_WELLS_TR_DATA,
  CHANGE_ESTDS,
  CHANGE_WSAR,
  CHANGE_INITNUM,
  CHANGE_WSSELROW,
  CHANGE_PREWL,
  CHANGE_SAME_DEPTH,
  CHANGE_BORING_SCORE,
  CHANGE_AUTOSCRCHK,
  CHANGE_CONSIDERMAT,
  CHANGE_BUDGET,
  CHANGE_UNITCOST,
  CHANGE_MAXSCRNUM,
  CHANGE_ANALYSISTYPE,
  CHANGE_OPTWS,
  CHANGE_CHKC,
  CHANGE_CHKK,
  CHANGE_TMPLAT,
  CHANGE_TMPLON,
  CHANGE_TMPGL,
  CHANGE_TMPWL,
  UPDATE_TMPUSERDATA,
  CHANGE_CHECKPREIND,
  CHANGE_ITSELROW,
  CHANGE_INITTEMP,
  CHANGE_CPLAT,
  CHANGE_CPLON,
} from "./actions";

const initData = {
  //サーバーからボーリングデータを読み込んだ場合true
  finBoringLoad: false,
  catData: [{ ID: 1, name: "未設定" }],
  catSelRow: null,
  regNum: 0,
  selRow: null,
  isDel: false,
  listCat: 0,
  name: "",
  cat: 0,
  geoInfo: "0",
  coordSystem: "0",
  color: "#ffffff",
  tab: "csv",
  isOk: false,
  isDraw: false,
  file: "",
  XAttr: 0,
  YAttr: 0,
  depThkRdo: "dep",
  ZAttr: 0,
  geo: 0,
  ID: 0,
  GLChk: false,
  GL: 0,
  WLChk: false,
  WL: 0,
  rowNum: 1,
  headerNum: 0,
  fieldNameChk: true,
  csvData: [],
  newData: [],
  formData: [],
  userData: {},
  selRowP: null,
  isDelP: false,
  uID: "",
  newDs: [],
  //トップボタンのボーリングカラー
  bColor: "exVar", //（exVar=説明変数）******ボーリング深度・予測確率を追加予定
  exVarCat: "river",
  exVarName: "",
  exVarNameOpt: [],
  pumping: "",
  pompTrData: [],
  screenTrData: [],
  wellsTrData: [],
  pompTrSelRow: null,
  initNum: 0,
  wsSelRow: null,
  preWL: null,
  sameDepth: 0,
  boringScore: "",
  autoScrChk: false,
  considerMat: 3,
  budget: 2000000,
  unitCost: 10000,
  maxScrNum: 1,
  analyType: 2,
  optWS: false,
  chkk: null,
  tmpLat: 0,
  tmpLon: 0,
  tmpGl: 0,
  tmpWl: 0,
  tmpUserData: [],
  checkPreInd: null,
  itSelRow: null,
  initTemp: 12,
  cpLat: 0,
  cpLon: 0,
};

export function boringReducer(state = initData, action) {
  switch (action.type) {
    case FIN_BORINGLOAD:
      return finBoringLoadReduce(state, action);
    case CHANGE_REGNUM:
      return changeRegNumReduce(state, action);
    case ADD_DS:
      return addDsReduce(state, action);
    case CHANGE_DS:
      return changeDsReduce(state, action);
    case CHANGE_ALLDS:
      return changeAllDsReduce(state, action);
    case CHANGE_BORDS:
      return changeBorDsReduce(state, action);
    case DEL_DS:
      return delDsReduce(state, action);
    case CHANGE_SELROW:
      return changeSelRowReduce(state, action);
    case ISDEL:
      return isDelReduce(state, action);
    case CHANGE_LISTCAT:
      return changeListCatReduce(state, action);
    case CHANGE_SHOWCHK:
      return changeShowChkReduce(state, action);
    case CHANGE_USECHK:
      return changeUseChkReduce(state, action);
    case ADD_CAT:
      return addCatReduce(state, action);
    case DEL_CAT:
      return delCatReduce(state, action);
    case CHANGE_CATNAME:
      return changeCatNameReduce(state, action);
    case CHANGE_CATSELROW:
      return changeCatSelRowReduce(state, action);
    case CHANGE_NAME:
      return changeNameReduce(state, action);
    case CHANGE_CAT:
      return changeCatReduce(state, action);
    case CHANGE_GEOINFO:
      return changeGeoInfoReduce(state, action);
    case CHANGE_COORDSYSTEM:
      return changeCoordSystemReduce(state, action);
    case CHANGE_COLOR:
      return changeColorReduce(state, action);
    case CHANGE_TAB:
      return changeTabReduce(state, action);
    case ISOK:
      return isOkReduce(state, action);
    case ISDRAW:
      return isDrawReduce(state, action);
    case CHANGE_FILE:
      return changeFileReduce(state, action);
    case CHANGE_XATTR:
      return changeXAttrReduce(state, action);
    case CHANGE_YATTR:
      return changeYAttrReduce(state, action);
    case CHANGE_DEPTHKRDO:
      return changeDepThkRdoReduce(state, action);
    case CHANGE_ZATTR:
      return changeZAttrReduce(state, action);
    case CHANGE_GEO:
      return changeGeoReduce(state, action);
    case CHANGE_ID:
      return changeIDReduce(state, action);
    case CHANGE_GLCHK:
      return changeGLChkReduce(state, action);
    case CHANGE_GL:
      return changeGLReduce(state, action);
    case CHANGE_WLCHK:
      return changeWLChkReduce(state, action);
    case CHANGE_WL:
      return changeWLReduce(state, action);
    case CHANGE_HEADERNUM:
      return changeHeaderNumReduce(state, action);
    case CHANGE_FIELDNAMECHK:
      return changeFieldNameChkReduce(state, action);
    case CHANGE_CSVDATA:
      return changeCsvDataReduce(state, action);
    case CHANGE_NEWDATA:
      return changeNewDataReduce(state, action);
    case CHANGE_FORMDATA:
      return changeFormDataReduce(state, action);
    case CHANGE_USERBORINGDATA:
      return changeUserDataReduce(state, action);
    case ADD_POINT:
      return addPointReduce(state, action);
    case DEL_POINT:
      return delPointReduce(state, action);
    case CHANGE_SELROWP:
      return changeSelRowPReduce(state, action);
    case IS_DELP:
      return isDelPReduce(state, action);
    case CHANGE_FIELD:
      return changeFieldReduce(state, action);
    case CHANGE_NEWDS:
      return changeNewDsReduce(state, action);
    case ADD_LASTGEO:
      return addLastGeoReduce(state, action);
    case CHANGE_BCOLOR:
      return changeBColorReduce(state, action);
    case CHANGE_EXVARCAT:
      return changeExVarCatReduce(state, action);
    case CHANGE_EXVARNAME:
      return changeExVarNameReduce(state, action);
    case CHANGE_EXVARNAMEOPT:
      return changeExVarNameOptReduce(state, action);
    case CHANGE_ANALYRADIUS:
      return changeAnalyRadiusReduce(state, action);
    case CHANGE_ANALYBHHEIGHT:
      return changeAnalyBHHeightReduce(state, action);
    case CHANGE_ANALYPUMP:
      return changeAnalyPumpReduce(state, action);
    case CHANGE_ANALYWL:
      return changeAnalyWLReduce(state, action);
    case CHANGE_MESHRADIUS:
      return changeMeshRadiusReduce(state, action);
    case CHANGE_MESHVERTEX:
      return changeMeshVertexReduce(state, action);
    case CHANGE_MESHSPLIT:
      return changeMeshSplitReduce(state, action);
    case CHANGE_MESHZSPLIT:
      return changeMeshZSplitReduce(state, action);
    case CHANGE_MESHBIAS:
      return changeMeshBiasReduce(state, action);
    case CHANGE_ANALYTARGET:
      return changeAnalyTargetReduce(state, action);
    case CHANGE_POMPAMOUNT:
      return changePompAmountReduce(state, action);
    case CHANGE_WLDAMOUNT:
      return changeWLDAmountReduce(state, action);
    case CHANGE_MODELKIND:
      return ModelKindReduce(state, action);
    case ADD_POMPTR:
      return addPompTrReduce(state, action);
    case ADD_SCREENTR:
      return addScreenTrReduce(state, action);
    case DEL_POMPTR:
      return delPompTrReduce(state, action);
    case DEL_SCREENTR:
      return delScreenTrReduce(state, action);
    case UPDATE_POMPTR:
      return updatePompTrReduce(state, action);
    case CHANGE_POMPTRSELROW:
      return changePompTrSelRowReduce(state, action);
    case CHANGE_SCREENZSPLIT:
      return changeScreenZSplitReduce(state, action);
    case CHANGE_MAPMESHLAY:
      return changeMapMeshLayReduce(state, action);
    case CHANGE_EQUPERMCHECK:
      return changeEquPermCheckReduce(state, action);
    case CHANGE_PROBTHRESHOLD:
      return changeProbThresholdReduce(state, action);
    case CHANGE_CROSSVALID:
      return changeCrossValidReduce(state, action);
    case ADD_WELLSTR:
      return addWellsTrReduce(state, action);
    case UPDATE_WELLS_TR_DATA:
      return updateWellsTrReduce(state, action);
    case CHANGE_ESTDS:
      return changeEstDsReduce(state, action);
    case CHANGE_WSAR:
      return changeWsArReduce(state, action);
    case CHANGE_INITNUM:
      return changeInitNumReduce(state, action);
    case CHANGE_WSSELROW:
      return changeWsSelRowReduce(state, action);
    case CHANGE_PREWL:
      return changePreWLReduce(state, action);
    case CHANGE_SAME_DEPTH:
      return changeSameDepthReduce(state, action);
    case CHANGE_BORING_SCORE:
      return changeBoringScoreReduce(state, action);
    case CHANGE_AUTOSCRCHK:
      return changeAutoScrChkReduce(state, action);
    case CHANGE_CONSIDERMAT:
      return changeConsiderMatReduce(state, action);
    case CHANGE_BUDGET:
      return changeBudgetReduce(state, action);
    case CHANGE_UNITCOST:
      return changeUnitCostReduce(state, action);
    case CHANGE_MAXSCRNUM:
      return changeMaxScrNumReduce(state, action);
    case CHANGE_ANALYSISTYPE:
      return changeAnalysisTypeReduce(state, action);
    case CHANGE_OPTWS:
      return changeOptWSReduce(state, action);
    case CHANGE_CHKK:
      return changeChkKReduce(state, action);
    case CHANGE_CHKC:
      return changeChkCReduce(state, action);
    case CHANGE_TMPLAT:
      return changeTmpLatReduce(state, action);
    case CHANGE_TMPLON:
      return changeTmpLonReduce(state, action);
    case CHANGE_TMPGL:
      return changeTmpGlReduce(state, action);
    case CHANGE_TMPWL:
      return changeTmpWlReduce(state, action);
    case UPDATE_TMPUSERDATA:
      return changeTmpUserDataReduce(state, action);
    case CHANGE_CHECKPREIND:
      return changeCheckPreIndReduce(state, action);
    case CHANGE_ITSELROW:
      return changeITSelRowReduce(state, action);
    case CHANGE_INITTEMP:
      return changeInitTempReduce(state, action);
    case CHANGE_CPLAT:
      return changeCpLatReduce(state, action);
    case CHANGE_CPLON:
      return changeCpLonReduce(state, action);

    default:
      return state;
  }
}

export function finBoringLoadReduce(state, action) {
  return {
    ...state,
    finBoringLoad: action.isFin,
  };
}

export function changeRegNumReduce(state, action) {
  return {
    ...state,
    regNum: action.value,
  };
}

export function addDsReduce(state, action) {
  return {
    ...state,
    dataset: state.dataset.concat(action.data),
  };
}

export function changeDsReduce(state, action) {
  return {
    ...state,
    dataset: state.dataset.map(el => (el.ID === action.data.ID ? action.data : el)),
  };
}

export function changeAllDsReduce(state, action) {
  return {
    ...state,
    dataset: action.data,
  };
}

export function changeBorDsReduce(state, action) {
  return {
    ...state,
    // dataset の配列要素を更新
    dataset: state.dataset.map((el, i) => {
      if (i == action.data.boringID1) {
        for (let j = 0; j < el.data.length; j++) {
          if (el.data[j].ido_ID == action.data.data.ido_ID) {
            el.data[j] = action.data.data;
            break; // 条件に一致した要素が見つかったらループを終了
          }
        }
      }
      return el;
    }),
  };
}

export function delDsReduce(state, action) {
  return {
    ...state,
    dataset: state.dataset.filter((el, index) => index !== action.rowID),
  };
}

export function changeSelRowReduce(state, action) {
  return {
    ...state,
    selRow: action.rowID,
  };
}

export function isDelReduce(state, action) {
  return {
    ...state,
    isDel: action.isDel,
  };
}

export function changeListCatReduce(state, action) {
  return {
    ...state,
    listCat: action.value,
  };
}

export function changeShowChkReduce(state, action) {
  return {
    ...state,
    dataset: state.dataset.map(el => (el.ID === action.value ? action.data : el)),
  };
}

export function changeUseChkReduce(state, action) {
  return {
    ...state,
    dataset: state.dataset.map(el => (el.ID === action.value ? action.data : el)),
  };
}

export function addCatReduce(state, action) {
  return {
    ...state,
    catData: state.catData.concat({ ID: action.ID, name: "" }),
  };
}

export function delCatReduce(state, action) {
  return {
    ...state,
    catData: state.catData.filter(el => el.ID !== action.rowID),
  };
}

export function changeCatNameReduce(state, action) {
  return {
    ...state,
    catData: action.data,
  };
}

export function changeCatSelRowReduce(state, action) {
  return {
    ...state,
    catSelRow: action.rowID,
  };
}

export function changeNameReduce(state, action) {
  return {
    ...state,
    name: action.name,
  };
}

export function changeCatReduce(state, action) {
  return {
    ...state,
    cat: action.cat,
  };
}

export function changeGeoInfoReduce(state, action) {
  return {
    ...state,
    geoInfo: action.value,
  };
}

export function changeCoordSystemReduce(state, action) {
  return {
    ...state,
    coordSystem: action.coordSystem,
  };
}

export function changeColorReduce(state, action) {
  return {
    ...state,
    color: action.color,
  };
}

export function changeTabReduce(state, action) {
  return {
    ...state,
    tab: action.tab,
  };
}

export function isOkReduce(state, action) {
  return {
    ...state,
    isOk: action.isOk,
  };
}

export function isDrawReduce(state, action) {
  return {
    ...state,
    isDraw: action.isDraw,
  };
}

export function changeFileReduce(state, action) {
  return {
    ...state,
    file: action.file,
  };
}

export function changeXAttrReduce(state, action) {
  return {
    ...state,
    XAttr: action.value,
  };
}

export function changeYAttrReduce(state, action) {
  return {
    ...state,
    YAttr: action.value,
  };
}

export function changeDepThkRdoReduce(state, action) {
  return {
    ...state,
    depThkRdo: action.value,
  };
}

export function changeZAttrReduce(state, action) {
  return {
    ...state,
    ZAttr: action.value,
  };
}

export function changeGeoReduce(state, action) {
  return {
    ...state,
    geo: action.value,
  };
}

export function changeIDReduce(state, action) {
  return {
    ...state,
    ID: action.value,
  };
}

export function changeGLChkReduce(state, action) {
  return {
    ...state,
    GLChk: action.checked,
  };
}

export function changeGLReduce(state, action) {
  return {
    ...state,
    GL: action.value,
  };
}

export function changeWLChkReduce(state, action) {
  return {
    ...state,
    WLChk: action.checked,
  };
}

export function changeWLReduce(state, action) {
  return {
    ...state,
    WL: action.value,
  };
}

export function changeHeaderNumReduce(state, action) {
  return {
    ...state,
    headerNum: action.value,
  };
}

export function changeFieldNameChkReduce(state, action) {
  return {
    ...state,
    fieldNameChk: action.checked,
  };
}

export function changeCsvDataReduce(state, action) {
  return {
    ...state,
    csvData: action.csvData,
  };
}

export function changeNewDataReduce(state, action) {
  return {
    ...state,
    newData: action.newData,
  };
}

export function changeUserDataReduce(state, action) {
  console.log("Action received in reducer:", action);
  console.log("Current state:", state);
  return {
    ...state,
    userData: action.data,
  };
}

export function changeFormDataReduce(state, action) {
  return {
    ...state,
    formData: action.formData,
  };
}

export function addPointReduce(state, action) {
  return {
    ...state,
    userData: state.userData.concat({
      ido_ID: "",
      lon: 0,
      lat: 0,
      GL: 0,
      WL: 0,
      geo: [],
      userPoint: action.index,
    }),
  };
}

export function delPointReduce(state, action) {
  return {
    ...state,
    userData: state.userData.filter((el, index) => index !== action.rowID),
  };
}

export function changeSelRowPReduce(state, action) {
  return {
    ...state,
    selRowP: action.rowID,
  };
}

export function isDelPReduce(state, action) {
  return {
    ...state,
    isDelP: action.isDel,
  };
}

export function changeFieldReduce(state, action) {
  return {
    ...state,
    userData: action.data,
  };
}

export function changeNewDsReduce(state, action) {
  return {
    ...state,
    newDs: action.data,
  };
}

export function addLastGeoReduce(state, action) {
  //    return {
  //        ...state,
  //        newDs: state.newDs.map((el, index) =>
  //            (index === action.ID1) ?
  //                (el.map((el2, index2) =>
  //                    console.log(el2)
  //            )
  //        )
  //    };
}

export function changeBColorReduce(state, action) {
  return {
    ...state,
    bColor: action.value,
  };
}

export function changeExVarCatReduce(state, action) {
  return {
    ...state,
    exVarCat: action.value,
  };
}

export function changeExVarNameReduce(state, action) {
  return {
    ...state,
    exVarName: action.value,
  };
}

export function changeExVarNameOptReduce(state, action) {
  return {
    ...state,
    exVarNameOpt: action.opt,
  };
}

export function changeAnalyRadiusReduce(state, action) {
  return {
    ...state,
    analyRadius: action.value,
  };
}

export function changeAnalyBHHeightReduce(state, action) {
  return {
    ...state,
    analyBHHeight: action.value,
  };
}

export function changeAnalyPumpReduce(state, action) {
  return {
    ...state,
    analyPump: action.value,
  };
}

export function changeAnalyWLReduce(state, action) {
  return {
    ...state,
    analyWL: action.value,
  };
}

export function changeMeshRadiusReduce(state, action) {
  return {
    ...state,
    meshRadius: action.value,
  };
}

export function changeMeshVertexReduce(state, action) {
  return {
    ...state,
    meshVertex: action.value,
  };
}

export function changeMeshSplitReduce(state, action) {
  return {
    ...state,
    meshSplit: action.value,
  };
}

export function changeMeshZSplitReduce(state, action) {
  return {
    ...state,
    meshZSplit: action.value,
  };
}

export function changeMeshBiasReduce(state, action) {
  return {
    ...state,
    meshBias: action.value,
  };
}

export function changeAnalyTargetReduce(state, action) {
  return {
    ...state,
    analyTarget: action.value,
  };
}

export function changePompAmountReduce(state, action) {
  return {
    ...state,
    pompAmount: action.value,
  };
}

export function changeWLDAmountReduce(state, action) {
  return {
    ...state,
    wldAmount: action.value,
  };
}

export function ModelKindReduce(state, action) {
  return {
    ...state,
    modelKind: action.value,
  };
}
export function addPompTrReduce(state, action) {
  return {
    ...state,
    pompTrData: state.pompTrData.concat({
      time: action.TIME,
      wl: action.WL,
      pomp: action.POMP,
    }),
  };
}

export function delPompTrReduce(state, action) {
  return {
    ...state,
    pompTrData: state.pompTrData.filter((el, index) => index !== action.rowID),
  };
}

export function updatePompTrReduce(state, action) {
  return {
    ...state,
    pompTrData: action.value,
  };
}

export function changePompTrSelRowReduce(state, action) {
  return {
    ...state,
    pompTrSelRow: action.rowID,
  };
}

export function addScreenTrReduce(state, action) {
  return {
    ...state,
    screenTrData: state.screenTrData.concat({
      ID: action.ID,
      top: action.TOP,
      bottom: action.BOTTOM,
    }),
  };
}

export function delScreenTrReduce(state, action) {
  return {
    ...state,
    screenTrData: state.screenTrData.filter((el, index) => index !== action.rowID),
  };
}

export function changeScreenZSplitReduce(state, action) {
  return {
    ...state,
    screenZSplit: action.value,
  };
}

export function changeMapMeshLayReduce(state, action) {
  return {
    ...state,
    mapMeshLay: action.value,
  };
}

export function changeEquPermCheckReduce(state, action) {
  return {
    ...state,
    equPermCheck: action.value,
  };
}

export function changeProbThresholdReduce(state, action) {
  return {
    ...state,
    probThreshold: action.value,
  };
}

export function changeCrossValidReduce(state, action) {
  return {
    ...state,
    crossValid: action.value,
  };
}

export function addWellsTrReduce(state, action) {
  return {
    ...state,
    wellsTrData: state.wellsTrData.concat({
      ID: action.ID,
      LAT: action.LAT,
      LON: action.LON,
      KIND: action.KIND,
      PA: action.PA,
      IT: action.IT,
    }),
  };
}

export function updateWellsTrReduce(state, action) {
  return {
    ...state,
    wellsTrData: action.value,
  };
}

export function changeEstDsReduce(state, action) {
  return {
    ...state,
    estDs: action.data,
  };
}

export function changeWsArReduce(state, action) {
  return {
    ...state,
    wsAr: action.value,
  };
}

export function changeInitNumReduce(state, action) {
  return {
    ...state,
    initNum: action.value,
  };
}

export function changeWsSelRowReduce(state, action) {
  return {
    ...state,
    wsSelRow: action.rowID,
  };
}

export function changePreWLReduce(state, action) {
  return {
    ...state,
    preWL: action.value,
  };
}

export function changeSameDepthReduce(state, action) {
  return {
    ...state,
    sameDepth: action.value,
  };
}

export function changeBoringScoreReduce(state, action) {
  return {
    ...state,
    boringScore: action.value,
  };
}

export function changeAutoScrChkReduce(state, action) {
  return {
    ...state,
    autoScrChk: action.value,
  };
}

export function changeConsiderMatReduce(state, action) {
  return {
    ...state,
    considerMat: action.value,
  };
}

export function changeBudgetReduce(state, action) {
  return {
    ...state,
    budget: action.value,
  };
}

export function changeUnitCostReduce(state, action) {
  return {
    ...state,
    unitCost: action.value,
  };
}

export function changeMaxScrNumReduce(state, action) {
  return {
    ...state,
    maxScrNum: action.value,
  };
}

export function changeAnalysisTypeReduce(state, action) {
  return {
    ...state,
    analyType: action.value,
  };
}

export function changeOptWSReduce(state, action) {
  return {
    ...state,
    optWS: action.value,
  };
}

export function changeChkKReduce(state, action) {
  return {
    ...state,
    chkK: action.value,
  };
}

export function changeChkCReduce(state, action) {
  return {
    ...state,
    chkC: action.value,
  };
}

export function changeTmpLatReduce(state, action) {
  return {
    ...state,
    tmpLat: action.value,
  };
}

export function changeTmpLonReduce(state, action) {
  return {
    ...state,
    tmpLon: action.value,
  };
}

export function changeTmpGlReduce(state, action) {
  return {
    ...state,
    tmpGl: action.value,
  };
}

export function changeTmpWlReduce(state, action) {
  return {
    ...state,
    tmpWl: action.value,
  };
}

export function changeTmpUserDataReduce(state, action) {
  return {
    ...state,
    tmpUserData: action.value,
  };
}

export function changeCheckPreIndReduce(state, action) {
  return {
    ...state,
    checkPreInd: action.value,
  };
}

export function changeITSelRowReduce(state, action) {
  return {
    ...state,
    iTSelRow: action.rowID,
  };
}

export function changeInitTempReduce(state, action) {
  return {
    ...state,
    initTemp: action.value,
  };
}

export function changeCpLatReduce(state, action) {
  return {
    ...state,
    cpLat: action.value,
  };
}

export function changeCpLonReduce(state, action) {
  return {
    ...state,
    cpLon: action.value,
  };
}
